import { render, staticRenderFns } from "./RequPush9008.vue?vue&type=template&id=c124097e&scoped=true&"
import script from "./RequPush9008.vue?vue&type=script&lang=js&"
export * from "./RequPush9008.vue?vue&type=script&lang=js&"
import style0 from "./RequPush9008.vue?vue&type=style&index=0&id=c124097e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c124097e",
  null
  
)

export default component.exports